import { API } from "../../../../common/api/constants";

// ПОЛУЧИТЬ СПИСОК ДОКУМЕНТОВ ПО ЗАКАЗУ
export const GET_DOCUMENTS_LIST = `${API}/orders/{order_id}/documents`; // GET

// СКАЧАТЬ ДОКУМЕНТ
export const DOWNLOAD_DOCUMENT = `${API}/utility/pdf/orders/{order_id}/download`; // GET
